<template>
	<div class="vx-col" v-if="show">
		<div class="vx-row">
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<h3>Ajouter un contact</h3>
			</div>
			<!-- BUTTON: CLOSE FORM -->
			<div class="vx-col sm:w-1/2 w-full mb-2" v-if="alreadyAdded">
				<vs-button
					class="float-right"
					radius
					color="primary"
					type="filled"
					icon-pack="feather"
					icon="icon-x"
					@click="closeForm"
				></vs-button>
			</div>
			<!-- /BUTTON: CLOSE FORM -->
		</div>
		<div class="vx-row mt-8">
			<div class="vx-col">
				<vue-simple-suggest
					:disabled="userIsSelected || userCreation || userEmailErr"
					pattern="\w+"
					v-model.lazy="userMail"
					:list="users"
					:max-suggestions="10"
					:min-length="1"
					:debounce="200"
					:filter-by-query="true"
					:prevent-submit="true"
					mode="input"
					:nullable-select="true"
					ref="suggestComponent"
					placeholder="Email"
					value-attribute="email"
					display-attribute="email"
				>
					<template slot="misc-item-above" slot-scope="{ suggestions }">
						<template v-if="suggestions.length <= 0"> </template>
					</template>

					<div
						slot="suggestion-item"
						slot-scope="scope"
						:title="scope.suggestion.description"
					>
						<div class="text">
							<span v-html="boldenSuggestion(scope)"></span>
						</div>
					</div>
				</vue-simple-suggest>
			</div>
			<div class="vx-col">
				<vs-button
					v-if="userIsSelected || userCreation || userEmailErr"
					color="primary"
					type="border"
					class="mb-2 mr-3"
					@click="unselectContact"
					>Desélectionner le contact</vs-button
				>
				<vs-button
					v-else
					color="primary"
					type="border"
					class="mb-2 mr-3"
					@click="selectContact"
					>Vérifier si le contact existe</vs-button
				>
			</div>
			<div class="vx-col">
				<strong v-if="userIsSelected"
					>Le contact a bien été sélectionné. Remplissez les champs
					manquants.</strong
				>
				<strong v-if="userCreation"
					>Aucun contact n'a été trouvé. Veuillez créer le contact.</strong
				>
				<strong v-if="userEmailErr"
					>L'adresse mail saisie n'est pas valide.</strong
				>
			</div>
		</div>
		<span v-if="userIsSelected || userCreation">
			<hr class="mt-2" />
			<!-- CIVILITE -->
			<div class="vx-row w-1/4 mt-8">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-radio
						v-model="contact.civility"
						vs-name="Madame"
						vs-value="1"
						class="mr-4"
						>Madame</vs-radio
					>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-radio v-model="contact.civility" vs-name="Monsieur" vs-value="2"
						>Monsieur</vs-radio
					>
				</div>
				<vx-tooltip
					v-if="validators['civility'] && validators['civility'].errText !== ''"
					:text="errText('civility')"
					class="ml-3"
				>
					<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
				</vx-tooltip>
			</div>
			<!-- /CIVILITE -->
			<!-- PRENOM NOM -->
			<div class="vx-row mt-5">
				<!-- PRENOM -->
				<div class="vx-col sm:w-1/2 w-full mb-2 flex">
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="person" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							:style="styleValidator('firstname')"
							:disabled="userIsSelected"
							class="w-full"
							placeholder="Prénom"
							v-model="contact.firstname"
							:danger="
								ContactValidationObjects.firstnameValidationObject.notValid
							"
							:danger-text="
								ContactValidationObjects.firstnameValidationObject.errText
							"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="
							validators['firstname'] && validators['firstname'].errText !== ''
						"
						:text="errText('firstname')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
					<!-- /PRENOM -->
				</div>
				<!-- NOM -->
				<div class="vx-col sm:w-1/2 w-full mb-2 flex">
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="person" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							:style="styleValidator('lastname')"
							:disabled="userIsSelected"
							class="w-full"
							placeholder="Nom"
							v-model="contact.lastname"
							:danger="
								ContactValidationObjects.lastnameValidationObject.notValid
							"
							:danger-text="
								ContactValidationObjects.lastnameValidationObject.errText
							"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="
							validators['lastname'] && validators['lastname'].errText !== ''
						"
						:text="errText('lastname')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- /NOM -->
			</div>
			<!-- PRENOM NOM -->
			<!-- PHONE -->
			<div class="vx-row mt-5">
				<!-- PHONE -->
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="local_phone" size="small"></vs-icon
								></span>
							</div>
						</template>
						<!-- <vs-input
            :disabled="userIsSelected"
            class="w-full"
            placeholder="Téléphone"
            v-model="contact.phone"
            :danger="ContactValidationObjects.phoneValidationObject.notValid"
            :danger-text="ContactValidationObjects.phoneValidationObject.errText"
          /> -->
						<vs-input
							:style="styleValidator('phone')"
							:disabled="userIsSelected"
							class="w-full"
							placeholder="Téléphone"
							v-model="contact.phone"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="validators['phone'] && validators['phone'].errText !== ''"
						:text="errText('phone')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- /PHONE -->
			</div>
			<!-- /PHONE -->
			<!-- TYPE(FACTURATION/COMMERCIAL) HASACCESS TO DASHBOARD -->
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-select
						autocomplete
						v-model="contact.type"
						class="w-1/2 select-large mt-4"
						label="Type de contact"
						@change="validateOne(contact.type, 'type')"
						:danger="ContactValidationObjects.typeValidationObject.notValid"
						:danger-text="ContactValidationObjects.typeValidationObject.errText"
					>
						<vs-select-item
							:key="index"
							:value="item.value"
							:text="item.text"
							v-for="(item, index) in typeOptions"
							class="w-full"
						/>
					</vs-select>
					<vx-tooltip
						v-if="validators['type'] && validators['type'].errText !== ''"
						:text="errText('type')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- HASACCESS -->
				<vs-checkbox
					:disabled="userIsSelected"
					class="inline-flex mt-4"
					v-model="contact.hasAccess"
					>Accès au dashboard</vs-checkbox
				>
				<!-- /HASACCESS -->
			</div>
			<!-- /TYPE(FACTURATION/COMMERCIAL) HASACCESS TO DASHBOARD -->
			<!-- BUTTONS: RESET / SUBMIT -->
			<div class="vx-row float-right">
				<div class="vx-col w-full">
					<vs-button
						color="warning"
						type="border"
						class="mb-2 mr-3"
						@click="resetFields"
						>Réinitialiser</vs-button
					>
					<vs-button class="mb-2" @click="validateAll">Ajouter</vs-button>
				</div>
			</div>
			<!-- /BUTTONS: RESET / SUBMIT -->
		</span>
	</div>
</template>

<script>
import { Contact } from "@/entities/Contact";
import Validator from "@/entities/Validator";
import utilsMixin from "@/mixins/utilsMixin";
import validatorMixin from "@/mixins/validatorMixin";
import VueSimpleSuggest from "vue-simple-suggest";

import store from "@/store/store";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "ContactForProvider",
	props: {
		contactAdded: Number,
		provider: Number,
		show: Boolean,
	},
	components: {
		VueSimpleSuggest,
		VxTooltip,
	},
	mixins: [utilsMixin, validatorMixin],
	data() {
		return {
			// USER OBJECT
			contact: Contact.getFormFields(),
			selectedUser: null,
			userMail: null,
			userIsSelected: false,
			userCreation: false,
			userEmailErr: false,
			alreadyAdded: this.contactAlreadyAdded(),
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS FOR "TYPE"
			typeOptions: [
				{ text: "Facturation", value: 1 },
				{ text: "Commercial", value: 2 },
				{ text: "Technique", value: 5 },
				{ text: "Collaborateur externe", value: 7 },
			],
			// CONTACT VALIDATORS
			ContactValidationObjects: {
				civilityValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "civilityConstraint",
					required: true,
				},
				firstnameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "firstnameConstraint",
					required: true,
				},
				lastnameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "lastnameConstraint",
					required: true,
				},
				typeValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "typeConstraint",
					required: true,
				},
				emailValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "emailConstraint",
					required: true,
				},
				/*
				 * phoneValidationObject: {
				 *   valid: false,
				 *   notValid: false,
				 *   validText: null,
				 *   errText: null,
				 *   constraintName: "phoneConstraint",
				 *   required: true
				 * },
				 */
				hasAccessValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "hasAccessConstraint",
					required: true,
				},
			},
			validators: {},
			check: true,
		};
	},
	computed: {
		users: () => {
			return store.state.users;
		},
	},
	created() {
		this.getAllUsers();
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	/*
	 * watch: {
	 *   alreadyAdded: function(){
	 *     this.contactAlreadyAdded();
	 *   }
	 * },
	 */
	methods: {
		boldenSuggestion(scope) {
			if (!scope) return scope;
			const { suggestion, query } = scope;
			let result = this.$refs.suggestComponent.displayProperty(suggestion);
			if (!query) return result;
			const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
			return result.replace(
				new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
				"$1<b>$2</b>$3"
			);
		},
		selectContact() {
			// Si le mail existe dans la liste sélectionner le client en remplissant les champs AFFICHES, SAUF TYPE qui lui peut changer
			if (this.userMail == "") {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez saisir une adresse mail.",
				});
			} else {
				this.validators["email"] = new Validator({
					constraintName: "emailConstraint",
				});
				this.validators["email"].check(this.userMail);
				if (this.validators["email"].valid == false) {
					//console.log("errrr");
					this.check = false;
					this.userEmailErr = true;
				} else {
					let foundUser = this.users.filter(
						(user) => user.email === this.userMail
					);
					if (foundUser.length > 0) {
						//console.log(foundUser);
						this.selectedUser = foundUser[0];
						this.contact.civility = this.selectedUser.civility;
						this.contact.firstname = this.selectedUser.firstname;
						this.contact.lastname = this.selectedUser.lastname;
						this.contact.phone = this.selectedUser.phone;
						this.contact.hasAccess = this.selectedUser.hasAccess;
						//Active le booléen pour bloquer les modifications et à l'enregistrement ne pas créer de nouvel utilisateur
						this.userIsSelected = true;
					} else {
						this.userCreation = true;
					}
				}
			}
		},

		unselectContact() {
			this.userIsSelected = false;
			this.userCreation = false;
			this.userEmailErr = false;
		},
		/**
		 * Query our Api to fetch all users
		 */
		getAllUsers() {
			this.$store.dispatch("getAllUsers");
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = name + "Constraint";
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			this.validators[name].errText == "" &&
			this.validators[name].valid == false
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false ? (this.check = false) : "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].valid == false) {
				if (name == "type") {
					return "border: 1px solid red !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
				}
			} else if (this.validators[name] && this.validators[name].valid == true) {
				if (name == "type") {
					return "border: 1px solid green !important; border-radius: 5px 5px 5px 5px;";
				} else {
					return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
				}
			} else {
			}
		},
		validateAll() {
			this.check = true;
			let fields = ["firstname", "lastname", "civility", "phone", "type"];

			if (!this.contact.firstname) this.contact.firstname = "Inconnu";
			if (!this.contact.lastname) this.contact.lastname = "Inconnu";
			if (!this.contact.phone) this.contact.phone = "0000000000";

			for (let i = 0; i < fields.length; i++) {
				let name = fields[i] + "Constraint";
				let value = this.contact[fields[i]];
				value == 0 ? (value = "0") : "";
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				this.validators[fields[i]].errText == "" &&
				this.validators[fields[i]].valid == false
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				this.validators[fields[i]].valid == false ? (this.check = false) : "";
				this.$forceUpdate();
			}
			this.check == true ? this.formSubmitted() : "";
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Client.vue
		 */
		async formSubmitted() {
			try {
				if (this.userIsSelected == true) {
					let user = this.contact;
					user.email = this.userMail;
					user.id = this.selectedUser.id;
					if (this.contact.type == 7 && this.contact.role == 2) {
						user.role = 1;
						user.hasAccess = 1;
						await this.$http.post(this.apiUrl + "users/update", {
							user,
						});
					} else {
						await this.$http.post(this.apiUrl + "users/update", {
							user,
						});
					}

					// Création de la relation user - provider
					this.$http
						.post(this.apiUrl + "usersProviders/add", {
							provider_id: this.$props.provider,
							users_id: this.selectedUser.id,
							type: this.contact.type,
						})
						.then(() => {
							this.contactAlreadyAdded();
							this.$vs.notify({
								title: "Succès",
								text: "Contact ajouté avec succès.",
							});
							this.$emit("closeFormAfterContactAdded", 1);
							// Reset the contact (to get a new one)
							this.contact = Contact.getFormFields();
							this.userIsSelected = false;
							this.userCreation = false;
							this.selectedUser = null;
						})
						.catch((err) => {
							//console.log(err);
							this.$vs.notify({
								title: "Erreur",
								text: "Le contact n'a pas été ajouté.",
							});
						});
				} else {
					// Création de l'utilisateur
					//console.log(this.userMail);
					this.$http
						.post(this.apiUrl + "users/new", {
							email: this.userMail,
							password: true,
							firstname: this.contact.firstname,
							lastname: this.contact.lastname,
							role: 2,
							phone: this.contact.phone,
							image_url: this.contact.image_url,
							commentary: this.contact.commentary,
							status: this.contact.status,
							type: this.contact.type,
							civility: this.contact.civility,
							hasAccess: this.contact.hasAccess,
						})
						.then((res) => {
							// Création de la relation user - provider
							this.$http
								.post(this.apiUrl + "usersProviders/addm", {
									provider_id: this.$props.provider,
									type: this.contact.type,
									email: this.userMail,
								})
								.then(() => {
									this.contactAlreadyAdded();
									this.$vs.notify({
										title: "Succès",
										text: "Contact ajouté avec succès.",
									});
									this.$emit("closeFormAfterContactAdded", 1);
									// Reset the contact (to get a new one)
									this.contact = Contact.getFormFields();
									this.userIsSelected = false;
									this.userCreation = false;
									this.selectedUser = null;
								})
								.catch((err) => {
									//console.log(err);
									this.$vs.notify({
										title: "Erreur",
										text: "Le contact n'a pas été ajouté.",
									});
								});
						})
						.catch((err) => {
							//console.log(err);
							this.$vs.notify({
								title: "Erreur",
								text: "Le contact n'a pas été ajouté.",
							});
						});
				}
			} catch (e) {
				//console.log(e.message);
			}
		},

		/**
		 * Closes the form
		 */
		closeForm() {
			this.$emit("closeForm", false);
		},

		contactAlreadyAdded() {
			this.alreadyAdded = this.contactAdded > 0;
			return this.alreadyAdded;
		},

		/**
		 * Checks if first name is valid
		 */
		checkFirstname() {
			this.checkHandler(
				this.contact.firstname,
				this.ContactValidationObjects.firstnameValidationObject
			);
		},
		/**
		 * Checks if last name is valid
		 */
		checkLastname() {
			this.checkHandler(
				this.contact.lastname,
				this.ContactValidationObjects.lastnameValidationObject
			);
		},

		/**
		 * Checks if email is valid
		 */
		checkEmail() {
			this.checkHandler(
				this.$refs.suggestComponent.text,
				this.ContactValidationObjects.emailValidationObject
			);
		},

		/**
		 * Checks if phone is valid
		 */
		checkPhone() {
			let phone = "";
			if (this.contact.phone) phone = this.contact.phone.split(" ").join("");
			this.checkHandler(
				phone,
				this.ContactValidationObjects.phoneValidationObject
			);
		},

		/**
		 * Checks if type is valid
		 */
		checkType() {
			this.checkHandler(
				this.contact.type,
				this.ContactValidationObjects.typeValidationObject
			);
		},

		resetFields() {
			this.resetForm(this.contact);
			this.checkType();
			/*
			 * this.checkPhone()
			 * this.checkEmail()
			 */
			this.checkLastname();
			this.checkFirstname();
		},
	},
};
</script>

<style scoped>
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.center {
	align-self: center;
}
</style>
